import { render, staticRenderFns } from "./MainCertificate.vue?vue&type=template&id=367864f2&scoped=true"
import script from "./MainCertificate.vue?vue&type=script&lang=js"
export * from "./MainCertificate.vue?vue&type=script&lang=js"
import style0 from "./MainCertificate.scss?vue&type=style&index=0&id=367864f2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367864f2",
  null
  
)

export default component.exports